import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { NextButton, PreviousButton } from '../../styles';
import { useRosaContext } from '../../context';

interface FooterProps {
	isNextDisabled?: boolean;
}

export function Footer({ isNextDisabled = false }: Readonly<FooterProps>) {
	const { onPreviousStep, onNextStep } = useRosaContext();

	return (
		<Row justify="center" gutter={[30, 0]}>
			<Col>
				<PreviousButton type="ghost" onClick={onPreviousStep}>
					{I18n.get('Back')}
				</PreviousButton>
			</Col>
			<Col>
				<NextButton type="primary" onClick={onNextStep} disabled={isNextDisabled}>
					{I18n.get('Next')}
				</NextButton>
			</Col>
		</Row>
	);
}
